import { ButtonColor } from "@/common/enum/button-color";
import { formatPhoneNumber } from "@/common/util/format-phone-number";
import { Button, Modal, TextInput } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { toastState } from "../../atoms/system/toast-state";
import { profileState } from "../../atoms/user/profile-state";
import { userService } from "../../services/user-service";
import { TextInputLabel } from "../label/TextInputLabel";
import { H4 } from "../typography/H4";

interface Props {
  closeModal: () => void;
}

export const PartnerPhoneModal: React.FC<Props> = ({ closeModal }) => {
  const [profile, setProfile] = useRecoilState(profileState);
  const [phone, setPhone] = useState(profile.phone);
  const setToast = useSetRecoilState(toastState);

  const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    setPhone(formattedValue);
  };

  const handleSubmit = async () => {
    const payload = {
      phone,
    };

    const updatePartnerResponse = await userService.updatePartnerAsync(
      profile.id,
      payload
    );
    if (updatePartnerResponse.ok) {
      const getMyresponse = await userService.getMe();
      if (!getMyresponse.ok) {
        return;
      }
      setProfile(getMyresponse.data);
      setToast({
        show: true,
        messages: [`연락처를 수정했습니다.`],
      });
      closeModal();
    }
  };

  useEffect(() => {
    setPhone(profile.phone);
  }, [profile]);

  const disabled = !phone || profile.phone == phone;

  return (
    <Modal size="2xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>연락처 수정</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="flex justify-center">
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col">
              <TextInputLabel required>연락처</TextInputLabel>
              <div className="flex items-center gap-[8px]">
                <TextInput
                  required
                  value={phone}
                  placeholder="연락처를 입력해주세요"
                  defaultValue={profile.phone}
                  name="phone"
                  onChange={handleTextInputChange}
                  className="w-[572px]"
                />
              </div>
            </div>

            <Button
              disabled={disabled}
              color={disabled ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
              onClick={handleSubmit}
              className="w-full"
              size={"xl"}
            >
              변경하기
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
